// Autogenerated from `packages/@members/copy/copy.generated/__copy__.ts.hbs`

import { toCopyComponent } from '@peloton/copy-generic/models';
import type { CopyHook } from '@peloton/copy-generic/models';
import toFormattedText from '@peloton/copy/toFormattedText';
import type { CopyIDs } from '../CopyIDs';
import { useAllCopy } from '../CopyProvider/CopyProvider';
import type { AcceptTerms } from '../models.generated/AcceptTerms';

export const useAcceptTerms: CopyHook<CopyIDs<typeof AcceptTerms>> = (id, values) => {
  const copy = useAllCopy();
  const value = copy?.acceptTermsCollection?.[id];

  if (!value) {
    console.error(`No copy found for id ${id}`);
    return '';
  }

  return toFormattedText(value, values) as string;
};

export const AcceptTermsCopy = toCopyComponent(useAcceptTerms);
